import {createSelector} from 'reselect'
import {convertData2JsonForm} from '../../../../shared/lib/convertData2JsonForm'
import {objectMap} from '../../../../../lib/utils/get-table-transform-schema-and-form-data'
import {addEnumValBySchema} from '../../../../shared/lib/addEnumValBySchema'
import {ActivityItems} from '../../../../components/v2/activity-timeline/types/types'

export const createSession = createSelector(
    (state: any) => state.session,
    sessionData => sessionData
)
const selectDeliveries = state => state.deliveries

const selectDeliveriesForm = createSelector(
    selectDeliveries,
    ({form}) => form
)

const selectDeliveriesEnums = createSelector(
    selectDeliveries,
    ({enums}) => enums
)

const selectDeliveriesStagePlan = createSelector(
    selectDeliveries,
    ({stagePlan}) => stagePlan
)

export const getDeliveryId = createSelector(
    selectDeliveries,
    ({id}) => id
)

export const getDeliveriesFormLoading = createSelector(
    selectDeliveriesForm,
    ({isLoading}) => isLoading
)

export const getDeliveriesFormError = createSelector(
    selectDeliveriesForm,
    ({error}) => error
)

export const getDeliveriesFormData = createSelector(
    selectDeliveriesForm,
    ({data}) => data
)

export const getDeliveriesStageCurrent = createSelector(
    getDeliveriesFormData,
    (formData) => formData?.stages?.current
)

export const getDeliveriesEnumsData = createSelector(
    selectDeliveriesEnums,
    ({data}) => data
)

export const getDeliveriesEnumsError = createSelector(
    selectDeliveriesEnums,
    ({error}) => error
)

export const getDeliveriesEnumsIsLoading = createSelector(
    selectDeliveriesEnums,
    ({isLoading}) => isLoading
)

const selectChatAvito = state => state.chatAvito

export const selectChatAvitoIsLoading = createSelector(
  selectChatAvito,
  ({isLoading}) => isLoading
)

export const selectChatAvitoData = createSelector(
  selectChatAvito,
  ({data}) => data
)

export const selectChatAvitoError = createSelector(
  selectChatAvito,
  ({error}) => error
)

export const getActiveAvitoChatId = createSelector(
  selectChatAvito,
  ({activeChatId}) => activeChatId
)

export const getActiveAvitoChat = createSelector(
  [selectChatAvitoData, getActiveAvitoChatId],
  (data, activeChatId) => {
      return data?.filter((chatItem) => chatItem.chat_id === activeChatId)[0]
  }
)

export const getVisibleFormData = createSelector(
    [getDeliveriesFormData, getDeliveriesEnumsData],
    (formData, enums) => {

        if (formData/* && enums*/) {
            const { data: form } = formData

            if (!form) {
                return false
            }

            const {
                resultObject,
                resultSchema
            } = convertData2JsonForm(form)

            const enumItems = enums?.['enum'] || []
            if (enums?.['city']) {
                enumItems.city_id = Object.values(objectMap(enums['city'], ([key, value]) => {
                    return [key, {id: parseInt(key), value: value}]
                }))
            }

            if (enums?.['region']) {
                enumItems.region_id = Object.values(objectMap(enums['region'], ([key, value]) => {
                    return [key, {id: parseInt(key), value: value}]
                }))
            }

            Object.keys(enumItems).forEach(code => {
                if (
                    resultSchema?.properties.hasOwnProperty(code)
                ) {
                    const enumValues = enums?.['enum']?.[code] || {}
                    const oneOf: Record<string, string>[] = []

                    Object.keys(enumValues).forEach(enumValue => {
                        return oneOf.push({
                            'const': enumValues[enumValue].id,
                            'title': enumValues[enumValue].value
                        })
                    })

                    if (resultSchema?.properties.hasOwnProperty(code)) {
                        addEnumValBySchema(resultSchema, code, oneOf, enumValues)
                    }

                    if (resultObject.hasOwnProperty(code)) {
                        resultObject[code] = resultObject[code] ? resultObject[code] : null
                    }
                }
            })

            return { resultSchema, resultObject }
        }
    }
)

const selectDeliveriesTimeline = createSelector(
    selectDeliveries,
    ({timeline}) => timeline
)

export const selectDeliveriesTimelineData = createSelector(
    selectDeliveriesTimeline,
    ({data}) => data
)

export const selectDeliveriesTimelineFiles = createSelector(
    selectDeliveriesTimelineData,
    ({items}: { items: ActivityItems[] }) => {
        if (!items || items?.length === 0) {
            return []
        }

        return items?.map((activityItems) => {
            const files = activityItems?.items?.filter((activityItem) => activityItem.type === "file")
            return files?.length ? {...activityItems, items: files} : undefined
        }).filter((_) => Boolean(_)) as ActivityItems[]
    }
)

export const selectDeliveriesTimelineIsLoading = createSelector(
    selectDeliveriesTimeline,
    ({isLoading}) => isLoading
)

export const selectDeliveriesTimelineError = createSelector(
    selectDeliveriesTimeline,
    ({error}) => error
)

export const selectDeliveriesStagePlanData = createSelector(
    selectDeliveriesStagePlan,
    ({items}) => items
)


export const selectDeliveriesStagePlanIsLoading = createSelector(
    selectDeliveriesStagePlan,
    ({isLoading}) => isLoading
)

export const selectDeliveriesStagePlanError = createSelector(
    selectDeliveriesStagePlan,
    ({error}) => error
)
